import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { HELP_DOCUMENT_API} from "./apiRoutes";

const mutateAddHelpDocument = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${HELP_DOCUMENT_API}`, data, 
    { headers: { "Content-Type": "multipart/form-data" } }
  );
};

const useAddHelpDocumentMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddHelpDocument,
    ...queryParams,
  });

export default useAddHelpDocumentMutation;
